module.exports = "/fonts/trialProofer-iconPack.ttf?a315a04611b969a656671793b5593919";